import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FoodItem.css';
import { useSocket } from '../../context/SocketContext';
import { Howl } from 'howler';
import { buildApiUrl } from '../../config/api.config';

const FoodItem = ({ id, name, description, price, image, date, category }) => {
  const navigate = useNavigate();
  const socket = useSocket();
  const [imageError, setImageError] = useState(!image);
  const [currentFood, setCurrentFood] = useState({
    id, name, description, price, image, date, category
  });

  const clickSound = new Howl({
    src: ['/sounds/click.mp3'],
    volume: 0.5
  });

  useEffect(() => {
    if (socket) {
      socket.on('foodUpdated', (updatedFood) => {
        if (updatedFood._id === id) {
          setCurrentFood(updatedFood);
        }
      });

      return () => {
        socket.off('foodUpdated');
      };
    }
  }, [socket, id]);

  const handleViewMore = () => {
    clickSound.play();
    navigate(`/food/${id}`, { 
      state: { 
        name: currentFood.name, 
        description: currentFood.description, 
        price: currentFood.price, 
        image: currentFood.image, 
        date: currentFood.date, 
        category: currentFood.category 
      } 
    });
  };

  return (
    <div className="main-food-div">
      <div className="food-item">
        {imageError ? (
          <div className="food-placeholder" style={{
            width: '100%',
            height: '16rem',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.01) 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'rgba(255,255,255,0.1)',
            fontSize: '4rem'
          }}>
            <i className="fa-solid fa-utensils"></i>
          </div>
        ) : (
          <img
            className="food-item-image"
            src={buildApiUrl(`/uploads/${currentFood.image}`)}
            alt={currentFood.name}
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <div className="food-item-info">
        <div className="food-item-name-price">
          <p className="food-item-name">{currentFood.name}</p>
          <p className="food-item-price">₹{currentFood.price}</p>
        </div>
        <div className="view-more" onClick={handleViewMore}>
          View More
        </div>
      </div>
    </div>
  );
};

export default FoodItem;